import {FilterLineupsByCorrelationStackCombinationsInterface} from './filter-lineups-by-correlation-stack-combinations-interface';

export function getFilteredLineupsByCorrelationStackCombinations(
    lineups,
    filterLineupsByCorrelationStackCombinations: FilterLineupsByCorrelationStackCombinationsInterface,
) {
    if (!filterLineupsByCorrelationStackCombinations.hasCheckedCombinations()) {
        return Object.values(lineups.all());
    }

    const lineupIds = filterLineupsByCorrelationStackCombinations.getLineupIds();

    return lineupIds.map((lineupId) => lineups.getLineup(lineupId)).filter((lineup) => lineup !== null);
}
